import { LuLogOut, LuUserRound } from 'react-icons/lu';
import { useLocation } from 'react-router-dom';

import { ActionSheetItem } from 'src/shared/components/ui/ActionSheet';
import Avatar from 'src/shared/components/ui/Avatar';
import { ROLE_LABELS } from './roles';
import { useBusiness, useLogout, useSession } from './useAuth';

interface AccountSectionProps {
  /** Closes the sheet when "Mi cuenta" navigates away from it. */
  onNavigate?: () => void;
}

/**
 * Who is signed in, her account, and the way out. Shown in the shell's
 * account sheet.
 *
 * Composed into the shell the same way feature nav items are: the shell
 * imports the piece, the feature owns it.
 */
export default function AccountSection({ onNavigate }: AccountSectionProps) {
  const user = useSession();
  const { data: business } = useBusiness();
  const logout = useLogout();
  const { pathname } = useLocation();

  if (!user) return null;

  const name = user.fullName || user.email;

  return (
    <>
      <div className="v-account-card">
        <Avatar name={name} size={44} variant="ink" />
        <div className="v-account-card__text">
          <span className="v-account-card__name">{name}</span>
          <span className="v-account-card__meta">
            {ROLE_LABELS[user.role] ?? user.role}
            {business ? ` · ${business.name}` : ''}
          </span>
        </div>
      </div>
      <ActionSheetItem
        icon={LuUserRound}
        label="Mi cuenta"
        hint="Tu nombre y tu contraseña"
        to="/cuenta"
        active={pathname === '/cuenta'}
        onClick={onNavigate}
      />
      <ActionSheetItem
        icon={LuLogOut}
        label={logout.isPending ? 'Cerrando sesión…' : 'Cerrar sesión'}
        onClick={() => logout.mutate()}
        disabled={logout.isPending}
        danger
      />
    </>
  );
}
